import { privateAPI } from '@api/core'
import { AdminService } from '@api/service/adminService'
import { throwError } from '@api/utils/throwError'
import { response } from 'express'

export const adminDataRemote = (): AdminService => ({
  getUserList: async (query) => {
    try {
      const response = await privateAPI.get({
        url: `/admin/user`,
        params: query,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  getUserDetail: async (userUUID) => {
    try {
      const response = await privateAPI.get({
        url: `/admin/user/${userUUID}`,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  fetchUser: async (userUUID, body) => {
    try {
      const response = await privateAPI.patch({
        url: `/admin/user/${userUUID}`,
        data: body,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  deleteUser: async (userUUID) => {
    try {
      const response = await privateAPI.delete({
        url: `/admin/user/${userUUID}`,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  changeAuthorities: async (userUUID, authorities) => {
    try {
      const response = await privateAPI.put({
        url: `/admin/user/${userUUID}/authorities`,
        data: authorities,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  getNoticeList: async (query) => {
    try {
      const response = await privateAPI.get({
        url: `/admin/notice`,
        params: query,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  changeNoticePriority: async (id, command) => {
    try {
      const response = await privateAPI.patch({
        url: `/admin/notice/swap-priority/${id}`,
        params: { command },
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  createNotice: async (title, content, startDate, endDate) => {
    try {
      const response = await privateAPI.post({
        url: `/admin/notice`,
        data: { title, content, startDate, endDate },
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  getNoticeDetail: async (noticeUUID) => {
    try {
      const response = await privateAPI.get({
        url: `/admin/notice/${noticeUUID}`,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  modifyNoticeDetail: async (body) => {
    try {
      const response = await privateAPI.put({
        url: `/admin/notice`,
        data: body,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  deleteNotice: async (noticeUUID) => {
    try {
      const response = await privateAPI.delete({
        url: `/admin/notice/${noticeUUID}`,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  getPostList: async (query) => {
    try {
      const response = await privateAPI.get({
        url: `/post`,
        params: query,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  createPostNotice: async (title, content, startDate, endDate) => {
    try {
      const response = await privateAPI.post({
        url: `/admin/post`,
        data: { title, content, startDate, endDate },
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  getPostDetail: async (postUUID) => {
    try {
      const response = await privateAPI.get({
        url: `/post/${postUUID}`,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  deletePost: async (postUUID) => {
    try {
      const response = await privateAPI.delete({
        url: `/admin/post/${postUUID}`,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  getPostReply: async (postUUID) => {
    try {
      const response = await privateAPI.get({
        url: `/reply/post/${postUUID}`,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  createReply: async (postUUID, content) => {
    try {
      const response = await privateAPI.post({
        url: `/reply/post/${postUUID}`,
        data: { content, replyId: null },
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  createReReply: async (postUUID, content, replyId) => {
    try {
      const response = await privateAPI.post({
        url: `/reply/post/${postUUID}`,
        data: { content, replyId },
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  deleteReply: async (replyId) => {
    try {
      const response = await privateAPI.delete({
        url: `/admin/reply/${replyId}`,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  getEventList: async (query) => {
    try {
      const response = await privateAPI.get({
        url: '/admin/event',
        params: query,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  changeEventPriority: async (id, command) => {
    try {
      const response = await privateAPI.patch({
        url: `/admin/event/swap-priority/${id}`,
        params: { command },
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  createEvent: async (title, url) => {
    try {
      const response = await privateAPI.post({
        url: '/admin/event',
        data: { title, url },
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  mdoifyEvent: async (body) => {
    try {
      const response = await privateAPI.put({
        url: '/admin/event',
        data: body,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
})
